namespace Solovis.UI {

    /*
     * BlockLayoutManager groups items that have categories into blocks. This is used for tabbed property view.
     * 
     * options:
     *  labelGetter: function(item) that returns label
     *  categoryGetter: function(item) that returns category
     * 
     *  itemPriorityGetter: function (item) that returns priority level for the items when sorted (lower number to appear earlier in sort order)
     */
    export class BlockLayoutManager {

        public _labelGetter: any;
        public _categoryGetter: any;
        public _blockPriorityGetter: any;
        public _itemPriorityGetter: any;

        public rootBlockList: any[];

        constructor(options) {
            this._labelGetter = options.labelGetter;
            this._categoryGetter = options.categoryGetter;

            this._blockPriorityGetter = options.blockPriorityGetter ? options.blockPriorityGetter : function () { return 0; };
            this._itemPriorityGetter = options.itemPriorityGetter ? options.itemPriorityGetter : function () { return 0; };

            this.rootBlockList = [];       
        }

        public _getOrCreateBlock(category: string) {
            if (!category) {
                category = "Other";
            }

            var parts = category.split("/");

            var currentBlock = null;

            for (var i = 0; i < parts.length; i++) {
                var part = parts[i].trim();

                var blockList;
                if (currentBlock == null) {
                    blockList = this.rootBlockList;
                }
                else {
                    blockList = currentBlock.childBlocks;
                }

                var found = false;
                for (var blockCo = 0; blockCo < blockList.length; blockCo++) {
                    var childBlock = blockList[blockCo];
                    if (childBlock.header == part) {
                        currentBlock = childBlock;
                        found = true;
                        break;
                    }
                }

                if (!found) {
                    // We need to create the block.
                    var newBlock = {
                        header: part,
                        childBlocks: [],
                        items: []
                    };

                    blockList.push(newBlock);
                    currentBlock = newBlock;
                }
            }

            return currentBlock;
        }

        public sortBlocks(): void {
            var self = this;

            var blockSortFunc = function (a, b) { return self._blockListSorter(a, b); };
            var itemSortFunc = function (a, b) { return self._itemListSorter(a, b); };

            var sortBlockList = function (blockList) {
                blockList.sort(blockSortFunc);

                $(blockList).each(function (i, block: any) {
                    sortBlockList(block.childBlocks);

                    block.items.sort(itemSortFunc);
                });
            };

            sortBlockList(this.rootBlockList);
        }

        public addItem(item): void {
            var label = this._labelGetter(item);
            var category = this._categoryGetter(item);

            var block = this._getOrCreateBlock(category);

            block.items.push({
                label: label,
                item: item
            });
        }

        public _blockListSorter(a, b): number {
            var headerA = a.header;
            var headerB = b.header;

            var priorityA = this._blockPriorityGetter(a);
            var priorityB = this._blockPriorityGetter(b);

            if (priorityA == priorityB) {
                return compareStringsCaseInsensitive(headerA, headerB);
            }
            else {
                if (priorityA < priorityB) {
                    return -1;
                }
                else if (priorityA > priorityB) {
                    return 1;
                }
            }
        }

        public _itemListSorter(a, b): number {
            var labelA = a.label;
            var labelB = b.label;

            var priorityA = this._itemPriorityGetter(a);
            var priorityB = this._itemPriorityGetter(b);

            if (priorityA == priorityB) {
                return compareStringsCaseInsensitive(labelA, labelB);
            }
            else {
                if (priorityA < priorityB) {
                    return -1;
                }
                else if (priorityA > priorityB) {
                    return 1;
                }
            }
        }
    }    

    var compareStringsCaseInsensitive = function (a, b): number {
        var aLower = a.toLowerCase();
        var bLower = b.toLowerCase();

        if (aLower < bLower) {
            return -1;
        }
        else if (aLower > bLower) {
            return 1;
        }
        else {
            return 0;
        }
    };

}